import React from 'react'
import { SlDrawer } from '@shoelace-style/shoelace/dist/react'
import BirdViewData from './BirdViewData';
import { roles } from '../../utils/constants';

function B2BPreview(props) {
    const handleClose = () =>{
        props.setShow(false)
    }
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
          event.preventDefault();
        }
      }
      function navigateToNewTab() {
        const url = '/home/help'; // The relative path to the new page
        const fullUrl = window.location.origin + url; // Construct the full URL
        window.open(fullUrl, '_blank');
      }
  return (
    <SlDrawer open={props.show} onSlAfterHide={handleClose} onSlRequestClose={handleRequestClose} style={{ "--size": "767px" }}>
        <BirdViewData brand={props.brand} language={props.language}  date={props.date} from="market" newspaper={props.newspaper} salesPerson_id={props.salesPerson_id} fetchW2n={props.fetchW2n} fetchAllNews={props.fetchAllNews} fetchW2nCampaign_type={props.fetchW2nCampaign_type}/>
        {localStorage.getItem('role') === roles.salesperson && <div slot="footer" className='flex !items-center justify-end text-xs'><span>Report an</span><button className='btn btn-link !text-xs' onClick={navigateToNewTab}>issue/Misrepresentation</button></div>}
    </SlDrawer>
  )
}

export default B2BPreview